import { onValue, ref } from "firebase/database";
import { useEffect, useMemo, useState } from "react";
import { db } from "../Firebase";
import CATEGORIES from "./categoryConfig";

const RecordCard = ({ record }) => {
  const { categoryLabel, data } = record;
  const photo = data.photo || data.logo;
  const title = data.name || data.orgName || categoryLabel;

  return (
    <div className="col-12 col-sm-6 col-lg-4 mb-4">
      <div className="card h-100 shadow-sm">
        {photo ? (
          <img
            src={photo}
            alt={title}
            className="card-img-top"
            style={{ height: 180, objectFit: "cover" }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
        ) : (
          <div
            className="d-flex align-items-center justify-content-center text-white"
            style={{ height: 100, background: "#213F6D", fontSize: 40 }}
          >
            🏅
          </div>
        )}
        <div className="card-body">
          <span className="badge mb-2" style={{ background: "#213F6D" }}>
            {categoryLabel}
          </span>
          <h6 className="card-title fw-bold">{title}</h6>
          {Object.entries(data)
            .filter(([k, v]) => k !== "photo" && k !== "logo" && v)
            .slice(0, 5)
            .map(([k, v]) => {
              const fieldDef = CATEGORIES.find((c) => c.id === record.categoryId)
                ?.fields.find((f) => f.name === k);
              return (
                <p key={k} className="mb-1 small text-muted">
                  <strong>{fieldDef?.label || k}:</strong> {v}
                </p>
              );
            })}
        </div>
      </div>
    </div>
  );
};

const VishishtPublic = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filterCat, setFilterCat] = useState("");

  useEffect(() => {
    const unsubscribe = onValue(ref(db, "vishisht_panjikaran"), (snap) => {
      if (snap.exists()) {
        const all = Object.entries(snap.val()).map(([id, v]) => ({ id, ...v }));
        setRecords(all.filter((r) => r.status === "approved"));
      } else {
        setRecords([]);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return records.filter((r) => {
      const matchCat = filterCat ? r.categoryId === filterCat : true;
      const matchSearch = q
        ? JSON.stringify(r.data).toLowerCase().includes(q) ||
          r.categoryLabel.toLowerCase().includes(q)
        : true;
      return matchCat && matchSearch;
    });
  }, [records, search, filterCat]);

  return (
    <div className="container py-5">
      {/* Header */}
      <div className="text-center mb-4">
        <h3 className="fw-bold" style={{ color: "#213F6D" }}>
          🏅 विशिष्ठ पंजीयन
        </h3>
        <p className="text-muted">Vishisht Panjikaran – Special Registrations</p>
      </div>

      {/* Filters */}
      <div className="row g-2 mb-4">
        <div className="col-12 col-md-6">
          <input
            className="form-control"
            placeholder="🔍 खोजें... (Search)"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-4">
          <select
            className="form-select"
            value={filterCat}
            onChange={(e) => setFilterCat(e.target.value)}
          >
            <option value="">सभी श्रेणियां (All Categories)</option>
            {CATEGORIES.map((c) => (
              <option key={c.id} value={c.id}>
                {c.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-12 col-md-2">
          <button
            className="btn w-100"
            style={{ background: "#213F6D", color: "#fff" }}
            onClick={() => { setSearch(""); setFilterCat(""); }}
          >
            रीसेट
          </button>
        </div>
      </div>

      {/* Results */}
      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border" style={{ color: "#213F6D" }} />
        </div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <h5>कोई रिकॉर्ड नहीं मिला।</h5>
        </div>
      ) : (
        <div className="row">
          {filtered.map((r) => (
            <RecordCard key={r.id} record={r} />
          ))}
        </div>
      )}
    </div>
  );
};

export default VishishtPublic;
